import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Plx from 'react-plx';

//import T from '../../../translate/T'
import Footer from './../../../../src/SPRINTA/Footer';
import { Container, ContainerFluid, Row, Col } from './../../../../src/SPRINTA/atoms/Grid';
import Button from './../../../../src/SPRINTA/atoms/Button';
import CoverImage from './../../../../src/SPRINTA/atoms/CoverImage';
import { Text } from './../../../../src/SPRINTA/atoms/Forms'
import { numberFormat, toDecimal } from './../../../../src/SPRINTA/helpers/Formatter'
import './../effects.css';
import ContactForm from '../../Components/ContactForm'
import Valign from '../../../SPRINTA/atoms/Valign'
import SlickCarousel from '../../third-party/SlickCarousel'
import style from './style.css'
import Avatar from '../../../SPRINTA/atoms/Avatar'

const taxas = {
   slim: {
      min: 3.9,
      tax: 8
   },
   standard: {
      min: 4.8,
      tax: 11.5
   },
   premium: {
      min: 9.48,
      tax: 15.8
   },
}

const headerparallax = [
  {
    start: 0,
    duration: 800,
    properties: [
      {
        startValue: 0,
        endValue: 50,
        property: "translateY"
      }
    ]
  }
]

class Eventos extends Component {
  constructor() {
    super();
    this.state = {
       balao1: 'hidden',
       balao2: 'hidden',
       balao3: 'hidden',
       item1: 'hidden',
       item2: 'hidden',
       item3: 'hidden',
       item4: 'hidden',
       item5: 'hidden',
       item6: 'hidden',
       stat1: 'hidden',
       stat2: 'hidden',
       stat3: 'hidden',
       stat4: 'hidden',
       stat5: 'hidden',
       stat6: 'hidden',
       value: "60,00",
       valueDecimal: 0,
       organizers: {
          status: 'loading',
          data: []
       }
    }


    axios.get(`${window.URL_API}users/certified_organizers/6`)
    .then(data => {
         this.setState({
            organizers: {
               status: 'done',
               data
            }
         })
      })
  }
  handleScroll() {
    //console.log(document.documentElement.scrollTop);
    var balao1 = 'balao1 animated zoomIn'
    var balao2 = 'balao2 animated zoomIn'
    var balao3 = 'balao3 animated zoomIn'
    if (document.documentElement.scrollTop > 200 && this.state.balao1 !== balao1){
      this.setState({
        balao1: balao1
      })
      setTimeout(function(){
        this.setState({
          balao2: balao2
        })
      }.bind(this), 300);
      setTimeout(function(){
        this.setState({
          balao3: balao3
        })
      }.bind(this), 800);
    }

    var item = 'instreduzaitem animated fadeIn'
    if (document.documentElement.scrollTop > 1600 && this.state.item1 !== item){
      setTimeout(function(){
         this.setState({
           item1: item
         })
      }.bind(this), 100)
      setTimeout(function(){
        this.setState({
          item2: item
        })
     }.bind(this), 300);
      setTimeout(function(){
        this.setState({
          item3: item
        })
     }.bind(this), 500);
      setTimeout(function(){
        this.setState({
          item4: item
        })
     }.bind(this), 700);
      setTimeout(function(){
        this.setState({
          item5: item
        })
     }.bind(this), 900);
      setTimeout(function(){
        this.setState({
          item6: item
        })
     }.bind(this), 1100);
    }

    var stat1 = 'stat1 animated zoomIn'
    var stat2 = 'stat2 animated zoomIn'
    var stat3 = 'stat3 animated zoomIn'
    var stat4 = 'stat4 animated zoomIn'
    var stat5 = 'stat5 animated zoomIn'
    var stat6 = 'stat6 animated zoomIn'
    if (document.documentElement.scrollTop > 2300 && this.state.stat1 !== stat1){
      this.setState({
        stat1: stat1
      })
      setTimeout(function(){
        this.setState({
          stat2: stat2
        })
      }.bind(this), 500);
      setTimeout(function(){
        this.setState({
          stat3: stat3
        })
     }.bind(this), 700);
      setTimeout(function(){
        this.setState({
          stat4: stat4
        })
     }.bind(this), 900);
      setTimeout(function(){
        this.setState({
          stat5: stat5
        })
     }.bind(this), 1100);
     setTimeout(function(){
         this.setState({
            stat6: stat6
         })
      }.bind(this), 1200);
    }
  }
  componentDidMount() {
   window.onscroll = () => this.handleScroll()
  }

   getPosition(element) {
      var xPosition = 0;
      var yPosition = 0;

      while(element) {
         xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
         yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
         element = element.offsetParent;
      }

      return { x: xPosition, y: yPosition };
   }

   goToCompare() {
      var to			= this.getPosition(this.refCompare).y - 80;
      var duration	= 300;
      var element 	= window;

      // element.scrollTop = 1200

      var start = window.document.documentElement.scrollTop,
      change  = to - start,
      currentTime = 0,
      increment	  = 20;

      var easeInOutQuad = function (t, b, c, d) {
         t /= d/2;
         if (t < 1) return c/2*t*t + b;
         t--;
         return -c/2 * (t*(t-2) - 1) + b;
      }

      var animateScroll = function(){
         currentTime += increment;
         var val = easeInOutQuad(currentTime, start, change, duration);
         element.scrollTo(0, val);
         if(currentTime < duration) {
            setTimeout(animateScroll, increment);
         }
      };
      animateScroll();
   }


   handlePriceChange( value ) {
      this.setState({
         value,
         valueDecimal: toDecimal(value)
      })
   }

   calcTax( plan ) {
      let value = this.state.valueDecimal
      let tax = value / 100 * taxas[plan].tax
      return tax < taxas[plan].min ? taxas[plan].min : tax
   }

  render() {
    return (
      <div>
        <ContainerFluid>
          <Row>
            <Col size="12" style={{paddingLeft: '0',paddingRight: '0'}}>
              <Plx
              className={style.instheader}
                parallaxData={ headerparallax }
              >
                <CoverImage className={style.instheader} image={require('./background.jpg')}>
                  <Container style={{ height: '530px' }}>
                     <Valign>
                       <h1>Seus eventos publicados<br />em menos de 5 minutos</h1>
                       <p>Crie rapidamente eventos e comunidades<br />sociais em torno do seu negócio</p>
                     </Valign>
                  </Container>
                </CoverImage>
              </Plx>
            </Col>
            <Col size="12" className={style.instmonte}>
              <Container>
                <Row>
                   <Col size="12 6" float="left right" className={style.instmonteright}>
                    <img alt="" src={require('./mac.png')}/>

                    <img alt="" src={require('./balao1.png')} className={this.state.balao1}/>
                    <img alt="" src={require('./balao3.png')} className={this.state.balao2}/>
                    <img alt="" src={require('./balao2.png')} className={this.state.balao3}/>
                  </Col>

                  <Col size="12 6" style={{marginTop: '80px'}} text="center left" float="right left" className={style.instmonteleft}>
                    <h1><b>Agilidade</b> e<br /><b>sem burocracia</b>:<br />Monte seu evento <b>rapidamente</b></h1>
                    <p>Rápido, fácil e sem burocracias. Em poucos passos você já pode divulgar os seus eventos e usufruir de uma plataforma especializada em eventos esportivos presente em mais de 12 estados brasileiros.</p>
                  </Col>

                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instgerencie}>
              <Container>
                <Row>
                  <Col size="12 6" float="left" className={style.instgerencieleft}>
                    <div className={style.instgerencieleftimg}>
                      <img alt="" src={require('./mac2.png')}/>
                    </div>
                  </Col>
                  <Col size="12 6" float="right" className={style.instgerencieright}>
                    <h1>Gerencie <b>tudo</b> em<br /><b>tempo real</b>, sem<br />depender de ninguém</h1>
                    <p>Um painel de controle totalmente automatizado que deixa você controlar e alterar todas as opções do seu evento em tempo real.</p>
                    <h2>Liberdade na sua gestão,<br />de qualquer lugar do mundo.</h2>
                    <div className={style.instquote}>
                      <p>Através do SPRINTA conseguimos melhorar o gerenciamento dos nossos eventos e relacionamento com as os atletas. facilitando o nosso trabalho e nosso trabalho e melhorando a nossa comunicação.</p>
                      <img alt="" src={require('./bolacha.jpeg')}/>
                      <span><b>Francisco Rauber</b><br />Federação Gaúcha de Ciclismo</span>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instreduza}>
              <Container>
                <Row>
                   <Col size="12 6" float="center right" className={style.instreduzaright}>
                    <Row>
                      <Col size="6">
                        <div className={this.state.item1}>
                          <img alt="" src={require('./icon1.png')}/>
                          <p>Cobranças<br />automatizadas</p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className={this.state.item2}>
                          <img alt="" src={require('./icon2.png')}/>
                          <p>Controles<br />de lotes</p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className={this.state.item3}>
                          <img alt="" src={require('./icon3.png')}/>
                          <p>Categorias<br />individuais ou<br />grupos</p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className={this.state.item4}>
                          <img alt="" src={require('./icon4.png')}/>
                          <p>Notificações<br />via e-mail<br />e/ou SMS</p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className={this.state.item5}>
                          <img alt="" src={require('./icon5.png')}/>
                          <p>Pagamento<br />com boleto ou<br />cartão de crédito</p>
                        </div>
                      </Col>
                      <Col size="6">
                        <div className={this.state.item6}>
                          <img alt="" src={require('./icon6.png')}/>
                          <p>Estatísticas<br />em tempo<br />real</p>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col size="12 6" text="center right" float="center left" className={style.instreduzaleft}>
                    <h1>Reduza seu<br />trabalho <b>em até 70%</b><br />automatizando tarefas</h1>
                    <p>Desde a divulgação do seu evento até a gestão dos atletas, categorais, lotes e cobranças são tarefas automatizadas pela plataforma.<br /><br />Através de um algoritmo inteligente o sistema trabalha para cuidar de toda a parte burocrátiva, deixando você livre para focar em outras tarefas da organização.</p>
                    <div className={style.instquote2}>
                      <p>Através do SPRINTA conseguimos melhorar o gerenciamento dos nossos eventos e relacionamento com as os atletas, facilitando o nosso trabalho e melhorando a nossa comunicação.</p>
                      <img alt="" src={require('./flavio.png')}/>
                      <span><b>Flávio Borges</b><br />Borges Eventos</span>
                    </div>
                  </Col>

                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instrede}>
              <Container>
                <Row>
                   <Col size="12 6" float="right" text="center left" className={style.instrederight}>
                    <h1>Forme <b>sua rede de<br />seguidores</b> e aumente o<br />público dos seus eventos</h1>
                    <p>A plataforma funciona como uma rede social com dezenas de milhares de atletas que automaticamente são avisados de todas as suas novidades, aumentando o número de participantes dos seus eventos e economizando seu tempo e investimento em marketing.</p>
                  </Col>

                  <Col size="12" style={{marginTop: '200px'}}>
                        <Row>
                            <Col size="12 6" text="center right" className={style.instredeleft}>
                                <h1><b>97% de aprovação</b><br />entre os atletas.<br /><b>100%</b> entre os<br /><b>organizadores</b></h1>
                                <p>Uma plataforma em constante evolução para facilitar o relacionamento dos atletas e a vida dos organizadores de eventos. Números que expressam a satisfação de nossos parceiros.</p>
                           </Col>

                           <Col size="12 6" hiddenSM hiddenMD text="center right" className={style.instrederight}>
                             <div className={style.instrederightstats}>
                               <img src={require('./stat1.png')} alt="" className={this.state.stat1} />
                               <img src={require('./stat2.png')} alt="" className={this.state.stat2} />
                               <img src={require('./stat3.png')} alt="" className={this.state.stat3} />
                               <img src={require('./stat4.png')} alt="" className={this.state.stat4} />
                               <img src={require('./stat5.png')} alt="" className={this.state.stat5} />
                               <img src={require('./stat6.png')} style={{
                                     position: 'relative',
                                     top: '70px'
                                  }} alt="" className={this.state.stat6} />
                             </div>
                           </Col>
                     </Row>
                  </Col>


                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instparceiros} style={{paddingLeft: '0',paddingRight: '0'}}>
              <Container>
                <Row>
                  <Col size="12 6" text="center left">
                     {this.state.organizers.data.map( img => (
                        <Col size='4' key={img.id_user} style={{position: 'relative', top: '40px', marginBottom: '10px'}}>
                           <Avatar size='120' href={`${window.URL_BASE_OLD}${img.user_uri}`} border="1px solid #ddd" img={`${window.URL_ASSETS_BASE}imgs/avt/${img.avatar}`}/>
                        </Col>
                     ) )}
                  </Col>
                  <Col size="12 6" style={{marginTop: '50px'}} text="center left">
                    <h1>A plataforma oficial<br />de grandes parceiros</h1>
                    <h2>+ de 700 eventos parceiros em 2016, distribuídos em 16 estados brasileiros</h2>
                    <p>O SPRINTA é uma plataforma oficial de diversas federações e<br />empresas de todo o Brasil. Seja você também nosso parceiro.</p>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col size="12" className={style.instplataforma}>
              <Container>
                <div className={style.instplataformamel}>
                  <h1>A <b>melhor plataforma</b> com as<br />melhores taxas e planos</h1>
                  <Row>
                    <Col size="6">
                      <p>Coloque o valor da sua inscrição<br />para simular as taxas abaixo</p>
                    </Col>
                    <Col size="6">
                       <Text value={this.state.value} handleChange={ e => this.handlePriceChange(e.target.value) } mask='money_br' placeholder="R$ 60,00" />
                    </Col>
                  </Row>
                </div>
                <div className={style.instplataformaplanos}>
                  <Row>
                     <SlickCarousel itens={4} centerPadding="60px">
                          {1 === 2 && (
                            <Col size="3" style={{ display: 'none' }}>
                              <div className={style.planbox}>
                                    <div className={style.instplanositem}>
                                      <h2>Repasse</h2>
                                      <p>Você recebe o valor integral e o atleta paga as taxas bancárias e de serviço.</p>
                                      <p className={style.instprice}>GRATUÍTO</p>
                                      { /*<Button inline color="orange-transparent">Criar evento</Button>*/ }
                                      <span>Possui as mesmas funcionalidades do plano Standard</span>
                                    </div>
                                </div>
                            </Col>
                          )}

                          <Col size="3">
                             <div className={style.planbox}>
                               <div className={style.instplanositem} style={{background:'white'}}>
                                 <h2>Start</h2>
                                 <p style={{borderBottom:'1px solid #F9F9F9'}}>O plano test drive para seu primeiro evento</p>
                                 <p className={style.instprice}>
                                    <span style={{ width: "100%", display: "block", marginTop: '-19px', fontSize: '13px' }}>a partir de:</span>
                                    R$ {numberFormat(1.97, 2, ',', '.')}
                                 </p>
                                 { /*<Button inline color="orange-transparent">Criar evento</Button>*/ }
                                 <Button inline theme="secondary" onClick={() => this.goToCompare()}>Mais detalhes</Button>

                                </div>
                              </div>
                          </Col>
                          <Col size="3">
                             <div className={style.planbox}>
                               <div className={style.instplanositem} style={{background:'white'}}>
                                 <h2>Slim</h2>
                                 <p style={{borderBottom:'1px solid #F9F9F9'}}>O plano básico para você que precisa apenas do essencial.</p>
                                 <p className={style.instprice}>R$ {numberFormat(this.calcTax('slim'), 2, ',', '.')}</p>
                                 { /*<Button inline color="orange-transparent">Criar evento</Button>*/ }
                                 <Button inline theme="secondary" onClick={() => this.goToCompare()}>Mais detalhes</Button>

                                </div>
                              </div>
                          </Col>
                          <Col size="3">
                             <div className={style.planbox}>

                               <div className={style.instplanositemstan}>
                               <div className={style.escolhida}>Opção mais escolhida</div>
                                 <h2>Standard</h2>
                                 <p>
                                  O plano principal, com todas as funcionalidades, para uma gestão completa do seu evento.
                                  <br />
                                  <i style={{position: 'relative', top: '15px'}}>Pode repassar taxa para os atletas</i>
                                 </p>
                                 <p className={style.instprice}>R$ {numberFormat(this.calcTax('standard'), 2, ',', '.')}</p>
                                 { /*<Button inline color="orange-transparent">Criar evento</Button>*/ }
                                 <Button inline theme="secondary" onClick={() => this.goToCompare()}>Mais detalhes</Button>
                               </div>
                            </div>
                          </Col>
                          <Col size="3">
                             <div className={style.planbox}>
                               <div className={style.instplanositem} style={{background:'white'}}>
                                 <h2>Premium</h2>
                                 <p style={{borderBottom:'1px solid #F9F9F9'}}>Suporte e promoção premium SPRINTA, com seguro do seu evento contra acidentes pessoais.</p>
                                 <p className={style.instprice}>R$ {numberFormat(this.calcTax('premium'), 2, ',', '.')}</p>
                                 { /*<Button inline color="orange-transparent">Criar evento</Button>*/ }
                                 <Button inline theme="secondary"  onClick={() => this.goToCompare()}>Mais detalhes</Button>
                              </div>
                            </div>
                          </Col>
                     </SlickCarousel>

                  </Row>
                </div>
              </Container>
              <Container className={style.instplataformacomp}>
                <h1 ref={ref => this.refCompare = ref}>Compare os planos<br />e <b>escolha o seu</b></h1>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Evento</h3>
                  </Col>
                  <Col size='12 10'>
                    <table style={{width:'100%'}}>
                       <thead>
                          <tr>
                           <th></th>
                           <th><span>Slim</span></th>
                           <th><span>Standard</span></th>
                           <th><span>Premium</span></th>
                          </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td>Hotsite do evento</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Lista de inscritos</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Sistema de perguntas</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Perfil do organizador</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Postagem de arquivos</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Postagem de fotos</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Download da lista de atletas</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Painel de controle</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Estatísticas do evento</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Pesquisa de satisfação pós-evento</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Certificado de participação do evento</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Cobrança</h3>
                  </Col>
                  <Col size='12 10'>
                    <table style={{width:'100%'}}>
                       <thead style={{ color: 'transparent' }}>
                         <tr>
                          <th></th>
                          <th><span>Slim</span></th>
                          <th><span>Standard</span></th>
                          <th><span>Premium</span></th>
                         </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td>Cobranças automatizadas</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Boleto bancário</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Cartão de crédito</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Repassar taxas aos atletas</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                        </tr>
                        <tr>
                          <td>Opção de dividir taxas com atletas</td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Suporte</h3>
                  </Col>
                  <Col size="12 10">
                    <table style={{width:'100%'}}>
                       <thead style={{ color: 'transparent' }}>
                         <tr>
                          <th></th>
                          <th><span>Slim</span></th>
                          <th><span>Standard</span></th>
                          <th><span>Premium</span></th>
                         </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td>Suporte via e-mail</td>
                          <td style={{textAlign:'center'}}>36 horas</td>
                          <td style={{textAlign:'center'}}>24 horas</td>
                          <td style={{textAlign:'center'}}>4 horas</td>
                        </tr>
                        <tr>
                          <td>Suporte telefônico</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Suporte via WhatsApp</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Gerente de conta SPRINTA</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Chat</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Promoção</h3>
                  </Col>
                  <Col size="12 10">
                    <table style={{width:'100%'}}>
                       <thead style={{ color: 'transparent' }}>
                         <tr>
                          <th></th>
                          <th><span>Slim</span></th>
                          <th><span>Standard</span></th>
                          <th><span>Premium</span></th>
                         </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td>Raio de promoção</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>300km</td>
                          <td style={{textAlign:'center'}}>600km</td>
                        </tr>
                        <tr>
                          <td>Página inicial da plataforma</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Presença no mailing SPRINTA</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>Regional</td>
                          <td style={{textAlign:'center'}}>Regional</td>
                        </tr>
                        <tr>
                          <td>Presença no mailing nacional</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>Opcional</td>
                          <td style={{textAlign:'center'}}>Opcional</td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Marketing</h3>
                  </Col>
                  <Col size="12 10">
                    <table style={{width:'100%'}}>
                       <thead style={{ color: 'transparent' }}>
                         <tr>
                          <th></th>
                          <th><span>Slim</span></th>
                          <th><span>Standard</span></th>
                          <th><span>Premium</span></th>
                         </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td>Crédito para envio de e-mail</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>1.000</td>
                          <td style={{textAlign:'center'}}>6.000</td>
                        </tr>
                        <tr>
                          <td>Envios de SMS para celular</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>-</td>
                          <td style={{textAlign:'center'}}>500</td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <div className={style.tables}>
                  <Col size='12 2' text="left right">
                    <h3>Especial<br />Premium</h3>
                  </Col>
                  <Col size="12 10">
                    <table style={{width:'100%'}}>
                       <thead style={{ color: 'transparent' }}>
                         <tr>
                          <th></th>
                          <th><span>Slim</span></th>
                          <th><span>Standard</span></th>
                          <th><span>Premium</span></th>
                         </tr>
                       </thead>
                      <tbody>
                        <tr>
                          <td><b>Suporte SPRINTA aos atletas</b><br />Nosso suporte dá um auxílio extra para os seus atletas:<br />Segunda via de boleto, troca de categorias e outras dúvidas.</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td><b>Seguro do atleta</b><br />Atleta já segurado contra acidentes pessoais.</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Selo do segurado</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                        <tr>
                          <td>Gerente de contas SPRINTA</td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.balltrans}></span></td>
                          <td style={{textAlign:'center'}}><span className={style.ballred}></span></td>
                        </tr>
                      </tbody>
                    </table>
                 </Col>
                </div>

                <Col size='6 4' float='right' style={{ marginTop: '50px' }}>
                    <a href='/create/event'>
                        <Button theme='primary'>Criar evento</Button>
                    </a>
                </Col>
              </Container>
            </Col>
            <Col size="12" className={style.instdesafioscrie}>
              <Container>
                <ContactForm />
              </Container>
            </Col>
          </Row>
        </ContainerFluid>
        <Footer lang="pt-BR" />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Eventos)



// WEBPACK FOOTER //
// ./src/App/pages/Eventos/index.js